module.exports = __webpack_public_path__ + "static/media/bottomArrowWhite.6ee31f7a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/BottomArrow/BottomArrowWhite/bottomArrowWhite.svg
// module id = 892
// module chunks = 21